<template>
  <section class="lui-details">
    <div class="file-details-wrapper">
      <div
        class="file-details-header"
        @click="clickSort($event)"
      >
        <div class="details-header-title">
          <div
            v-if="len === 0"
            class="details-header-filename"
          >
            <span>{{ $t('文件名') }}</span>
            <i
              class="icon"
              :class="['', 'i-sort-asc', 'i-sort-desc'][sortInfo.file.status]"
            />
          </div>
          <div
            v-else
            class="details-header-selected"
          >
            <span>
              {{ checkedName }}
            </span>
          </div>
        </div>
        <div class="details-header-size">
          <span>{{ $t('文件大小') }}</span>
          <i
            class="icon"
            :class="['', 'i-sort-asc', 'i-sort-desc'][sortInfo.size.status]"
          />
        </div>
      </div>
      <slot name="crumb" />
      <slot
        v-if="isLoading"
        name="loading"
      />
      <div
        v-else-if="!nothing"
        class="file-details-scroll"
        @scroll="loadMore($event)"
      >
        <template v-for="(list, index) in fileList">
          <div
            ref="fileitem"
            :key="index"
            :class="['file-details-item', { hover: list.hover }, { 'item-selected': list.checked }]"
            @mouseup="clickHandler($event, index)"
            @mouseenter="mouseenterHandler(index)"
            @mouseleave="mouseleaveHandler(index)"
          >
            <span
              ref="checkbox"
              class="pkg-checkbox"
            >
              <span
                class="box-checkbox-inner"
                :class="list.checked ? 'checkbox-checked' : ''"
              />
            </span>
            <div class="filelist-icon">
              <div class="file-area">
                <svg class="file-icon">
                  <use
                    ref="fileicon"
                    :xlink:href="getIcon(list)"
                  />
                </svg>
                <span
                  ref="filename"
                  class="file-name"
                  :title="list.fileName"
                >{{
                  list.fileName
                }}</span>
              </div>
              <div
                v-show="list.showOperate"
                ref="unpack"
                class="file-operate"
              >
                <span>{{ $t('解压到') }}</span>
              </div>
            </div>
            <div class="update-size">
              {{ list.size }}
            </div>
          </div>
        </template>
      </div>
      <slot
        v-else-if="nothing"
        name="nothing"
      />
    </div>
  </section>
</template>

<script>
import store from 'store'
import * as Util from 'js/util/util'

export default {
  components: {},
  props: {
    fileList: Array,
    accessMode: String,
    renderFinished: Boolean,
    isLoading: Boolean,
  },
  data() {
    return {
      checked: false,
      loadingMore: false,
      sortInfo: {
        file: {
          name: 'path',
          status: 0,
        },
        size: {
          name: 'bytes',
          status: 0,
        },
      },
    }
  },
  computed: {
    nothing() {
      return this.fileList.length === 0
    },
    len() {
      return store.getters.pkgSelectedLength
    },
    checkedName() {
      const { len: n } = this
      return this.$t('已选中{n}个文件/文件夹', { n })
    },
  },
  watch: {
    renderFinished(val) {
      if (val) {
        this.renderFinish()
      }
    },
  },
  methods: {
    clickSort(e) {
      if (this.nothing) {
        return
      }
      const { target } = e
      let orderby
      let sort
      if (target.parentNode.className === 'details-header-filename') {
        this.sortInfo.file.status = this.sortInfo.file.status === 1 ? 2 : 1
        this.sortInfo.size.status = 0
        orderby = 'path'
        sort = ['', 'desc', 'asc'][this.sortInfo.file.status]
      }
      if (target.parentNode.className === 'details-header-size') {
        this.sortInfo.size.status = this.sortInfo.size.status === 1 ? 2 : 1
        this.sortInfo.file.status = 0
        orderby = 'bytes'
        sort = ['', 'desc', 'asc'][this.sortInfo.size.status]
      }
      if (target.className === 'details-header-selected') {
        return
      }
      this.$emit('doSort', { orderby, sort })
    },
    getIcon(item) {
      if (item.isDir) {
        return '#folder'
      }
      return `#${Util.typeIcon(item.fileName.split('.').pop())}`
    },
    clickHandler(e, index) {
      const { target } = e
      const refs = this.$refs
      const checkbox = refs.checkbox[index]
      const name = refs.filename[index]
      const unpack = refs.unpack[index]
      const fileicon = refs.fileicon[index]
      const fileitem = refs.fileitem[index]
      const currentData = this.fileList[index]
      const { checked } = currentData
      if (e.button === 0) {
        // 左键
        if (e.ctrlKey) {
          // 按住ctrl
          this.CtrlAndClick({ index, currentData })
        } else if (e.shiftKey) {
          // 按住shift
          this.ShiftAndClick({ index, currentData })
        } else if (checkbox === target || checkbox === target.parentNode) {
          // 点checkbox
          this.CtrlAndClick({ index, currentData })
        } else if (name === target) {
          // 点名字
          if (!currentData.isDir) {
            this.singleNameSelect({ index, currentData })
            if (currentData.preview_url) {
              const fileType = `.${currentData.fileName.split('.').pop()}`
              if (Util.isCompressedFile(fileType)) {
                this.$emit('showTips', { message: this.$t('该类型的文件不支持预览'), type: 'error' })
                return
              }
              // 可预览的文件类型
              this.$emit('preview')
            }
            return
          }
          this.$emit('dirNameClick', currentData)
        } else if (unpack === target || unpack === target.parentNode) {
          // 解压
          this.singleNameSelect({ index, currentData })
          this.$emit('unpack', currentData)
        } else if (fileitem === target || fileitem === target.parentNode || fileicon === target) {
          this.singleSelect({ index, currentData })
        }
      } else if (e.button === 2) {
        // 右键
        if (!checked) {
          this.singleSelect({ index, currentData })
        }
      }
    },
    renderFinish() {
      this.loadingMore = false
    },
    loadMore(e) {
      const { target } = e
      if (target.clientHeight + target.scrollTop >= target.scrollHeight - 50 && !this.loadingMore) {
        this.loadingMore = true
        this.$emit('loadMore')
      }
    },
    mouseenterHandler(index) {
      const currentData = this.fileList[index]
      currentData.hover = true
      if (this.accessMode.includes('download')) {
        if (currentData.checked) {
          currentData.showOperate = store.getters.pkgSelectedLength === 1
        } else {
          currentData.showOperate = true
        }
      }
    },
    mouseleaveHandler(index) {
      const currentData = this.fileList[index]
      currentData.hover = false
      currentData.showOperate = false
    },
    selected(index, data) {
      Object.assign(data, {
        checked: true,
      })
      store.commit('addPkgData', { index, data })
    },
    unselected(index, data) {
      Object.assign(data, {
        checked: false,
      })
      store.commit('delPkgData', index)
    },
    toggleSelectStatus({ index, currentData }) {
      if (currentData.checked) {
        this.unselected(index, currentData)
      } else {
        this.selected(index, currentData)
      }
    },
    singleSelect({ index, currentData }) {
      if (currentData.checked && store.getters.pkgSelectedLength <= 1) {
        this.toggleSelectStatus({ index, currentData })
      } else {
        this.clearSelect()
        this.selected(index, currentData)
      }
      this.setLastSelectedData(index, currentData)
    },
    CtrlAndClick({ index, currentData }) {
      this.toggleSelectStatus({ index, currentData })
      if (currentData.checked) {
        this.setLastSelectedData(index, currentData)
      }
      if (store.getters.pkgSelectedLength > 1) {
        this.mouseleaveHandler(index)
      }
    },
    ShiftAndClick({ index, currentData }) {
      if (Object.keys(store.getters.pkgLastSelectedData).length === 0) {
        this.toggleSelectStatus({ index, currentData })
        this.setLastSelectedData(index, currentData)
      } else {
        const start = Math.min(index, store.getters.pkgLastSelectedData.index)
        const end = Math.max(index, store.getters.pkgLastSelectedData.index)
        this.fileList.forEach((item, i) => {
          if (i >= start && i <= end) {
            this.selected(i, item)
          } else {
            this.unselected(i, item)
          }
        })
      }
    },
    setLastSelectedData(index, data) {
      store.commit('setLastSelectedData', { index, data })
    },
    singleNameSelect({ index, currentData }) {
      if (!currentData.checked) {
        this.clearSelect()
        this.selected(index, currentData)
      }
      this.setLastSelectedData(index, currentData)
    },
    clearSelect() {
      this.fileList.forEach((item) => {
        Object.assign(item, {
          checked: false,
        })
      })
      store.commit('clearPkgData')
    },
  },
}
</script>

<style lang="less" scoped>
.lui-details {
  width: 630px;
  height: 352px;
  margin: 0 auto;
  border: 1px solid #c1c7cd;
  border-radius: 2px;
}
.file-details-wrapper {
  height: 100%;
  .file-details-header {
    height: 32px;
    padding: 0 5px 0 16px;
    line-height: 32px;
    color: #637282;
    border-bottom: 1px solid #c1c7cd;
    div {
      display: inline-block;
      cursor: pointer;
    }
    .details-header-size {
      float: right;
    }
    .details-header-filename,
    .details-header-selected,
    .details-header-size {
      span {
        font-size: 12px;
      }
      .i-sort-asc,
      .i-sort-desc {
        height: 10px;
      }
      .icon {
        vertical-align: middle;
      }
    }
  }
  .file-details-scroll {
    height: 257px;
    margin-top: 8px;
    overflow-x: hidden;
    overflow-y: auto;
    &::-webkit-scrollbar {
      width: 6px;
      height: 6px;
    }
    &::-webkit-scrollbar-thumb {
      background: #c1c7cd;
      border-radius: 100px;
      opacity: 0.6;
    }
    .file-details-item {
      position: relative;
      height: 40px;
      line-height: 40px;
      &.hover {
        background-color: #f0f2f6;
      }
      &.item-selected {
        background-color: #f0f2f6;
      }
      .pkg-checkbox {
        float: left;
        margin: 0 15px 0 16px;
        cursor: pointer;
      }
      .filelist-icon {
        display: inline-block;
        .file-area {
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          .file-icon {
            float: left;
            width: 22px;
            height: 26px;
            margin: 7px 14px 0 0;
          }
          .file-name {
            cursor: pointer;
            &:hover {
              text-decoration: underline;
            }
          }
        }
        .file-operate {
          position: absolute;
          top: 0;
          right: 110px;
          color: #0a64fa;
          cursor: pointer;
        }
      }
      .update-size {
        float: right;
        max-width: 80px;
        padding-right: 25px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    }
  }
}
</style>
